import React, {useCallback} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {useEventTracking} from 'src/hooks/useEventTracking';

import Button from '@pb/kit-component-button';

export const CreateAccountButton = () => {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const {accountCreateOpen} = useEventTracking();

    const handler = useCallback(() => {
        accountCreateOpen();
        navigate('/create-new-account', {state: {prevPath: pathname}});
    }, [navigate, accountCreateOpen, pathname]);

    const isDisabled = pathname === '/create-new-account';

    return (
        <Button variant="Type.SECONDARY" onClick={handler} disabled={isDisabled}>
            Create Account
        </Button>
    );
};
